import { FormattingAppender1iqfktuucnzpr as FormattingAppender } from './Appender.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var ConsoleOutputAppenderClass;
function ConsoleOutputAppender() {
  if (ConsoleOutputAppenderClass === VOID) {
    class $ extends FormattingAppender() {
      q2f(loggingEvent, formattedMessage) {
        switch (loggingEvent.z2f_1.b2_1) {
          case 0:
            console.log(formattedMessage);
            break;
          case 1:
            console.log(formattedMessage);
            break;
          case 2:
            console.info(formattedMessage);
            break;
          case 3:
            console.warn(formattedMessage);
            break;
          case 4:
            console.error(formattedMessage);
            break;
          case 5:
            break;
          default:
            noWhenBranchMatchedException();
            break;
        }
      }
    }
    initMetadataForClass($, 'ConsoleOutputAppender', ConsoleOutputAppender);
    ConsoleOutputAppenderClass = $;
  }
  return ConsoleOutputAppenderClass;
}
//region block: exports
export {
  ConsoleOutputAppender as ConsoleOutputAppender373h7g73cvnnw,
};
//endregion

//# sourceMappingURL=ConsoleOutputAppender.mjs.map
